import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Building2 } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { useLang } from "@/context/LangContext";

const inputCls =
  "w-full bg-[#0B132B] border border-white/12 rounded-xl px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-[#FFD166]/60";

export const Employers = () => {
  const { t } = useLang();
  const [form, setForm] = useState({ company_name: "", contact_name: "", email: "", phone: "", country: "", workers_needed: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.company_name || !form.contact_name || !form.email || !form.message) {
      toast.error(t("emp.errFields"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/employers", form);
      toast.success(t("emp.ok"));
      setForm({ company_name: "", contact_name: "", email: "", phone: "", country: "", workers_needed: "", message: "" });
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="empresas" data-testid="employers-section" className="py-16 md:py-24 bg-[#F5F7FB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-[#0B132B] to-[#253252] rounded-3xl border border-white/10 shadow-2xl p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#FFD166]/10 text-[#FFD166] border border-[#FFD166]/30 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider">
              <Building2 size={15} /> {t("emp.badge")}
            </div>
            <h2 className="font-head font-extrabold text-3xl md:text-4xl mt-5 leading-tight text-white">
              {t("emp.title")}
            </h2>
            <p className="text-slate-300 mt-4">{t("emp.desc")}</p>
            <div className="grid grid-cols-3 gap-4 mt-8">
              <div><div className="text-3xl font-head font-extrabold text-[#FFD166]">+5k</div><div className="text-xs text-slate-400">{t("emp.s1")}</div></div>
              <div><div className="text-3xl font-head font-extrabold text-[#FFD166]">15</div><div className="text-xs text-slate-400">{t("emp.s2")}</div></div>
              <div><div className="text-3xl font-head font-extrabold text-[#FFD166]">100%</div><div className="text-xs text-slate-400">{t("emp.s3")}</div></div>
            </div>
          </div>

          <form onSubmit={submit} data-testid="employer-form" className="space-y-4">
            <input data-testid="emp-company" className={inputCls} placeholder={t("emp.company")} value={form.company_name} onChange={(e) => set("company_name", e.target.value)} />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input data-testid="emp-contact" className={inputCls} placeholder={t("emp.contact")} value={form.contact_name} onChange={(e) => set("contact_name", e.target.value)} />
              <input data-testid="emp-email" type="email" className={inputCls} placeholder={t("emp.email")} value={form.email} onChange={(e) => set("email", e.target.value)} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input data-testid="emp-phone" className={inputCls} placeholder={t("emp.phone")} value={form.phone} onChange={(e) => set("phone", e.target.value)} />
              <input data-testid="emp-country" className={inputCls} placeholder={t("emp.country")} value={form.country} onChange={(e) => set("country", e.target.value)} />
            </div>
            <input data-testid="emp-workers" className={inputCls} placeholder={t("emp.workers")} value={form.workers_needed} onChange={(e) => set("workers_needed", e.target.value)} />
            <textarea data-testid="emp-message" rows={3} className={inputCls} placeholder={t("emp.message")} value={form.message} onChange={(e) => set("message", e.target.value)} />
            <button type="submit" disabled={loading} data-testid="emp-submit"
              className="w-full bg-[#FFD166] text-[#0B132B] font-bold py-3.5 rounded-full hover:bg-[#E0A926] transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
              {loading && <Loader2 className="animate-spin" size={18} />} {t("emp.submit")}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
